import { API_URL, Minisite_API_TOKEN, SOURCE_URL } from '../../config';
import { applyPreproductionSettings } from '../../utils/PreproductionSettings';

interface Content {
  type: string;
  text?: string;
  children?: Content[];
}

interface MinisiteComponent {
  __component: 'minisite.text-editor' | 'minisite.html-link';
  id: number;
  Content?: string | Content[]; // For minisite.text-editor
  HtmlLink?: string; // For minisite.html-link
}

interface SEO {
  Title: string;
  MetaDescription: string;
  MetaKeywords: string;
  MetaImage: string;
}

interface GA {
  Remarks: string;
  Location: string;
  Code: string;
}

interface MinisiteData {
  id: number;
  Title: string;
  Slug: string;
  HeaderMenu: 'General' | 'Hidden' | 'Logo & Language';
  FooterMenu: 'General' | 'Hidden' | 'Footer Menu Only';
  MinisiteDetails: MinisiteComponent[];
  SEO: SEO;
  GA: GA[];
  createdAt: string;
  updatedAt: string;
  publishedAt: string;
  locale: string;
}

interface MinisiteResponse {
  data: {
    id: number;
    attributes: MinisiteData;
  }[];
  meta: {
    pagination: {
      page: number;
      pageSize: number;
      pageCount: number;
      total: number;
    };
  };
}

export const fetchMinisite = async (slug: string, lang: string): Promise<MinisiteResponse> => {
  try {
    console.log(`Fetching minisite with slug: ${slug}`);
    let langpart = '';
    if (lang.indexOf('zh') > -1) {
      langpart = "&locale=zh-Hant-HK&fallbackLocale=false";
    }
    let url = `${API_URL}/minisites?filters[Slug][$eq]=${slug}&populate=MinisiteDetails,SEO.MetaImage,GA${langpart}`;
    url = applyPreproductionSettings(url);
    const response = await fetch(url, {
      headers: {
        Authorization: `Bearer ${Minisite_API_TOKEN}`,
      },
    });

    if (!response.ok) {
      console.error(`Error fetching minisite: ${response.statusText}`);
      throw new Error(`Error fetching minisite: ${response.statusText}`);
    }

     const responseData: MinisiteResponse = await response.json();

    // Apply SOURCE_URL for MetaImage if it exists
    if (responseData?.data?.[0]?.attributes?.SEO?.MetaImage?.data?.attributes?.url) {
      responseData.data[0].attributes.SEO.MetaImage = SOURCE_URL + responseData.data[0].attributes.SEO.MetaImage.data.attributes.url;
    }

    // Fallback for SEO Title if it doesn't exist but the main Title does.
    if (responseData?.data?.[0]?.attributes) {
      const attributes = responseData.data[0].attributes;
      if (attributes.SEO) {
        if (!attributes.SEO.Title && attributes.Title) {
          attributes.SEO.Title = attributes.Title;
        }
      } else if (attributes.Title) {
        attributes.SEO = { ...attributes.SEO, Title: attributes.Title };
      }
    }
    console.log('Minisite API Response:', responseData);
    return responseData;
  } catch (error) {
    console.error('Error fetching minisite.', error);
    throw error;
  }
};